<template lang="pug">
  div
    b-row
      b-col.order-md-2(md="4")
        b-card
          b-button(variant="primary", block, @click="new_keyword_modal=!new_keyword_modal") Nueva palabra clave
          hr
          .text-help
            alert-circle-icon.icon-md.mr-2
            span Las palabras clave permiten asignar un caso de forma automática al grupo que pertenece.
      b-col(md="8")
        b-card(no-body, style="width:100%;")
          b-table.card-table.table-nowrap.mb-0(:items="keywords", :fields="fields", responsive, show-empty, hover, @row-clicked="prevUpdate($event)")
            template(v-slot:cell(text)="data")
              b-link.text-dark(@click="prevUpdate(data.item)") {{ data.item.text }}
            template(v-slot:cell(group_id)="data") {{setGroupName(data.item.group_id)}}
            template(v-slot:empty)
              span.text-secondary No hay palabras clave creadas

    b-modal(v-model="new_keyword_modal", centered, title="Crear nueva palabra clave", cancel-title="Cancelar", ok-title="Crear", ok-variant="primary", @ok="createKeyword", @show="resetModal")
      b-container(fluid)
        label Palabra clave:
        b-form-input(v-model="new_keyword.text" placeholder="Palabra clave", trim, :state="(new_keyword.text && new_keyword.text.indexOf(' ') < 0) ? null : (new_keyword.validated ? false : null)")
        b-form-invalid-feedback No puede contener espacios
        b-form-group.mt-2(label="Grupo:", description="El grupo al que se va a derivar el caso.")
          b-form-select(v-model="new_keyword.group_id", :state="new_keyword.group_id ? null : (new_keyword.validated ? false : null)")
            option(:value="null" disabled) -- Seleccionar grupo --
            option(v-for="group in groups", :key="group.group_id" :value="group.group_id") {{group.name}}


    b-modal(v-model="update_keyword_modal", centered, title="Actualizar palabra clave", cancel-title="Cancelar", ok-title="Actualizar", ok-variant="primary", @ok="updateKeyword")
      b-container(fluid)
        label Palabra clave:
        b-form-input(v-model="update_keyword.text" placeholder="Nombre", trim, :state="(update_keyword.text && update_keyword.text.indexOf(' ') < 0) ? null : (update_keyword.validated ? false : null)")
        b-form-invalid-feedback(:state="(update_keyword.text && update_keyword.text.indexOf(' ') < 0) ? null : (update_keyword.validated ? false : null)") Sin espacios
        b-form-group.mt-2(label="Grupo:", description="El grupo al que se va a derivar el caso.")
          b-form-select(v-model="update_keyword.group_id", :state="update_keyword.group_id ? null : (update_keyword.validated ? false : null)")
            option(:value="null" disabled) Selecciona grupo...
            option(v-for="group in groups", :key="group.group_id" :value="group.group_id") {{group.name}}
      b-card.bg-light.text-center.text-sm.mb-0.mt-4
        alert-triangle-icon.icon-sm.mr-2
        span Eliminar palabra no se puede deshacer.
        p.mb-0.mt-2
          b-link.text-danger(@click="deleteKeyword(update_keyword)") Eliminar palabra
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const keywordController = createNamespacedHelpers('keyword')
const groupController = createNamespacedHelpers('group')

export default {
  data () {
    return {
      keywords: [],
      fields: [
        {
          key: 'keyword_id',
          label: 'ID'
        },
        {
          key: 'text',
          label: 'P. Clave'
        },
        {
          key: 'group_id',
          label: 'Grupo'
        }
      ],
      new_keyword_modal: false,
      new_keyword: {
        text: '',
        group_id: null,
        validated: false
      },
      update_keyword_modal: false,
      update_keyword: {
        text: '',
        group_id: null,
        validated: false
      },
    }
  },
  computed: {
    ...groupController.mapState({
      groups: state => state.groups
    }),
  },
  methods: {
    ...mapActions(['group/all', 'keyword/all', 'keyword/create', 'keyword/update', 'keyword/destroy']),
    getGroups () {
      let self = this
      this['group/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {

          }
        }
      })
    },
    getKeywords () {
      let self = this
      // this.showLoadingScreen()

      this['keyword/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.keywords = res.resource
          }
        }
      })
    },
    createKeyword (bvModalEvt) {
      if (!this.new_keyword.text || this.new_keyword.text.indexOf(' ') >= 0 || !this.new_keyword.group_id) {
        bvModalEvt.preventDefault()
        this.new_keyword.validated = true
        return
      }

      var self = this
      this['keyword/create']({
        account_id: self.$route.params.account_id,
        ...self.new_keyword,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.getKeywords()
          }
        }
      })
    },
    prevUpdate (keyword) {
      this.update_keyword = Object.assign(this.update_keyword, keyword)
      this.update_keyword_modal = !this.update_keyword_modal
    },
    updateKeyword (bvModalEvt) {
      if (!this.update_keyword.text || this.update_keyword.text.indexOf(' ') >= 0 || !this.update_keyword.group_id) {
        bvModalEvt.preventDefault()
        this.update_keyword.validated = true
        return
      }

      var self = this
      this['keyword/update']({
        ...self.update_keyword,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.getKeywords()
            self.update_keyword = {}
          }
        }
      })
    },
    async deleteKeyword (keyword) {
      var self = this
      try {
        let response = await this.$bvModal.msgBoxConfirm(`¿Deseas eliminar esta palabra clave? No se podrá recuperar.`, {
          title: 'Eliminar palabra clave',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar'
        })
        if(response){
          this['keyword/destroy']({
            ...keyword,
            callback: res => {
              if (res.error) {
                self.$message.error(res.error)
              } else {
                self.getKeywords()
                self.update_keyword_modal = false
              }
            }
          })
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    setGroupName (id) {
      let group = this.groups.find(g => g.group_id == id)
      return group ? group.name : ''
    },
    resetModal () {
      this.clearObject(this.new_keyword)
      this.new_keyword.group_id = null
    }
  },
  mounted () {
    this.getGroups()
    this.getKeywords()
  }
}
</script>

<style lang="css" scoped>
</style>
